<template>
  <div>
    <preload-content :loading="loading" min-height="55vh">
      <template v-if="!loading">
        <template v-if="categories.length">
          <tabs :tabs="categories" @changeTab="changeTab"/>
          <div v-if="category">
            <question
                v-for="(questionItem, idx) in questions.filter(val => val.category_id === category.id)"
                :key="idx"
                :title="questionItem.title"
                :desc="questionItem.description"
            />
          </div>
        </template>
        <template v-else>
          <h2>Список пуст</h2>
        </template>
      </template>
    </preload-content>
  </div>
</template>

<script>
import PreloadContent from '@/components/ui/preload-content';
import Tabs from '../../../../components/functional/Tabs'
import Question from './question'

export default {
  name: 'QnA',
  components: {
    Question, Tabs,
    PreloadContent
  },
  data: () => ({
    category: null,
    categories: null,
    questions: null,
  }),
  mounted() {
    this.loadCategories();
    this.loadQuestions();
  },
  computed: {
    loading() {
      return !this.questions || !this.categories;
    }
  },
  methods: {
    loadCategories() {
      this.$api.instruction.category.list().then(({data}) => {
        this.categories = data;
        if (this.categories.length) this.changeTab(0);
      });
      return this;
    },
    loadQuestions() {
      this.$api.instruction.list().then(({data}) => this.questions = data);
      return this;
    },
    changeTab(idx) {
      this.categories = this.categories.map((tab, tabIdx) => {
        tab.isActive = idx === tabIdx;
        if (tab.isActive) this.category = tab;
        return tab;
      })
    },
  }
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 991px) {
  h1 {
    font-size: 24px;
    line-height: 1.33;
    padding-top: 20px;
  }
}
</style>
